import * as React from "react";
import {CSSProperties} from "react";
import "./FeatureDetailImages.scss";
import {IFeature} from "../OverviewScreen";
import {TimelineMax} from "gsap/TimelineMax";
import {TweenMax} from "gsap/TweenMax";
import {Linear, Power1} from "gsap/EasePack";

export interface FeatureDetailImagesProps {
    active: boolean;
    visible: boolean;
    contentPath: string;
    feature: IFeature;
    fadeInProgress: number,
    index: number;
}

export class FeatureDetailImages extends React.Component<FeatureDetailImagesProps, {}> {

    fadeInAnimationTL: TimelineMax;

    state = {
        alpha: 0,
        featureAlpha: 1,
        featureInactiveAlpha: 0,
    };

    stateAnimationProxy: any = {
        alpha: 0,
        featureAlpha: 1,
        featureInactiveAlpha: 0,
    };

    constructor(props: any, context?: any) {
        super(props, context);

        this.fadeInAnimationTL = new TimelineMax();
        this.fadeInAnimationTL.to(this.stateAnimationProxy, 1, {
            alpha: 1,
            ease: Power1.easeInOut,
            onComplete: this.stateAnimationProxySynchronize,
            onUpdate: this.stateAnimationProxySynchronize
        });
        this.fadeInAnimationTL.pause();
    }

    stateAnimationProxySynchronize = () => {
        this.setState(
            this.stateAnimationProxy
        );

        this.updateVisibleAnimationState();
    };

    componentWillReceiveProps(nextProps: FeatureDetailImagesProps): void {
        if (nextProps.active != this.props.active || nextProps.visible != this.props.visible && nextProps.fadeInProgress >= 1) {
            const DUR: number = .3;

            TweenMax.to(this.stateAnimationProxy, DUR,
                {
                    featureAlpha: nextProps.active ? 1 : 0,
                    featureInactiveAlpha: (!nextProps.active && nextProps.visible) ? 1 : 0,
                    ease: Linear.easeInOut,
                    onComplete: this.stateAnimationProxySynchronize,
                    onUpdate: this.stateAnimationProxySynchronize
                }
            );
        }
        if (nextProps.fadeInProgress != this.props.fadeInProgress) {
            this.fadeInAnimationTL.progress(this.props.fadeInProgress);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        // only animation will be done
        // because this will be controlled by gsap, no rerender is needed
        return false;
    }

    /**
     * Method creates all feature detail images (highlighted components)
     * @returns {JSX.Element}
     */
    createFeatureDetailImage = (): JSX.Element => {
        const css: CSSProperties = {
            left: this.props.feature.imgDetail[0].$.x + "px",
            top: this.props.feature.imgDetail[0].$.y + "px",
        }
        return <img
            key={'di-' + this.props.index}
            style={css}
            className={'FeatureDetailImages detail-image-active detail-image-active-' + this.props.index}
            src={this.props.contentPath + this.props.feature.imgDetail[0].$.src}
        />;
    };

    /**
     * Method creates all feature detail images, which will be displayed as long no single feature is selected
     * @returns {JSX.Element}
     */
    createFeatureDetailImageInactive = (): JSX.Element => {
        const css: CSSProperties = {
            left: this.props.feature.imgDetailInactive[0].$.x + "px",
            top: this.props.feature.imgDetailInactive[0].$.y + "px",
        }
        return <img key={'dia-' + this.props.index}
                    style={css}
                    className={'FeatureDetailImages detail-image-inactive detail-image-inactive-' + this.props.index}
                    src={this.props.contentPath + this.props.feature.imgDetailInactive[0].$.src}
        />;
    };

    /**
     * Keep animation state as it should be via TweenMax updates
     */
    updateVisibleAnimationState = () => {
        TweenMax.set('.FeatureDetailImages.detail-image-' + this.props.index, {
            alpha: this.state.alpha
        });
        TweenMax.set('.FeatureDetailImages .detail-image-active-' + this.props.index, {
            alpha: this.state.featureAlpha
        });
        TweenMax.set('.FeatureDetailImages .detail-image-inactive-' + this.props.index, {
            alpha: this.state.featureInactiveAlpha
        });
    };

    render() {
        this.updateVisibleAnimationState();

        return <div
            className={'FeatureDetailImages detail-image-' + this.props.index}>
            {this.createFeatureDetailImage()}
            {this.createFeatureDetailImageInactive()}
        </div>;
    }
}
